import React, { ReactNode, useEffect, useState, useRef } from 'react';
import './SignUp.css';

interface SignUpLayoutProps {
  children: ReactNode;
  title: string;
  subtitle: string;
  currentStep: number;
  totalSteps: number;
  footer?: ReactNode;
  wide?: boolean;
}

const SignUpLayout: React.FC<SignUpLayoutProps> = ({
  children,
  title,
  subtitle,
  currentStep,
  totalSteps,
  footer,
  wide = false,
}) => {
  const [isContentVisible, setIsContentVisible] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  
  // Handle content transition
  useEffect(() => {
    setIsContentVisible(false);
    
    // Small delay to allow the content to hide before showing new content
    const timer = setTimeout(() => {
      setIsContentVisible(true);
    }, 150);
    
    return () => clearTimeout(timer);
  }, [title, subtitle, currentStep]); // Re-trigger animation when key props change
  
  return (
    <div className="signup-container">
      <div className={`signup-card${wide ? ' signup-card--wide' : ''}`}>
        <div className="signup-header">
          {totalSteps > 1 && (
            <div className="signup-progress">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div
                  key={i}
                  className={`signup-progress-step ${
                    i + 1 === currentStep ? 'active' : ''
                  }`}
                />
              ))}
            </div>
          )}
        </div>
        
        <div 
          ref={contentRef}
          className={`signup-content ${isContentVisible ? 'visible' : ''}`}
          style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
        >
          <h1 className="signup-title">{title}</h1>
          <p className="signup-subtitle">{subtitle}</p>
          
          {children}
        </div>
        
        {footer && <div className="signup-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default SignUpLayout; 